<template>
  <div class="wellness-overview fill-height">
    <radar-chart
      v-if="viewMode === 'chart'"
      :series="[{
        name: $t('table_headers.player_overview.score'),
        data: wellnessData
      }]"
      :xaxis="{
        categories: wellnessCategories
      }"
      :yaxis="{
        min: 0,
        max: 100,
        tickAmount: 5,
        labels: { offsetX: -13 }
      }"
      :height="height"
      class="fill-height"
      content-class="pa-0"
    >
      <template v-slot:header>
        <v-card-title class="px-6 pt-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.wellness_overview') }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </radar-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.wellness_overview') }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="tableData"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="height"
      >
        <template v-slot:item.category="{ item }">
          {{ item.category }}
        </template>
        <template v-slot:item.score="{ item }">
          {{ item.score }}%
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import RadarChart from '@/components/charts/RadarChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'WellnessOverviewChart',
  components: {
    RadarChart,
    VisualListToggle
  },
  props: {
    stats: {
      type: Object,
      required: true
    },
    height: {
      type: String,
      default: '250'
    },
    variables: {
      type: Array,
      default: () => []
    },
    event: {
      type: Object,
      default: () => ({})
    },
    player: {
      type: Object,
      default: () => ({})
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    wellnessData() {
      return [
        this.stats.FAT_perc || 0,
        this.stats.GMS_perc || 0,
        this.stats.MOO_perc || 0,
        this.stats.STL_perc || 0
      ]
    },
    wellnessCategories() {
      return [
        this.$t('table_headers.player_overview.fatigue'),
        this.$t('chart_legends.muscle_soreness'),
        this.$t('table_headers.player_overview.mood'),
        this.$t('table_headers.main_load.stress')
      ]
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.category'),
          value: 'category',
          sortable: false,
          width: '60%'
        },
        {
          text: this.$t('table_headers.player_overview.score'),
          value: 'score',
          sortable: true,
          align: 'center'
        }
      ]
    },
    tableData() {
      return this.wellnessCategories.map((category, index) => ({
        category: category,
        score: this.wellnessData[index]
      }))
    }
  }
}
</script>

<style scoped>
.wellness-overview {
  display: flex;
  flex-direction: column;
}
</style>
